var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 23,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1088_2760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0965 9.25645H28.6641V7.74757C28.6641 5.9682 27.2166 4.52051 25.4371 4.52051H15.0004C13.2211 4.52051 11.7734 5.96809 11.7734 7.74757V9.25645H3.34111C1.61943 9.25645 0.21875 10.657 0.21875 12.3786V34.3375C0.21875 36.0591 1.61943 37.4597 3.34111 37.4597H37.0964C38.8181 37.4597 40.2188 36.0591 40.2188 34.3375V12.3786C40.2189 10.6571 38.8183 9.25645 37.0965 9.25645ZM14.5003 7.74757C14.5003 7.47173 14.7248 7.24727 15.0005 7.24727H25.4372C25.7129 7.24727 25.9374 7.47173 25.9374 7.74757V9.25645H14.5003V7.74757ZM3.34121 11.9832H37.0965C37.3146 11.9832 37.4921 12.1606 37.4921 12.3786V19.5334C33.2669 21.1007 26.8939 22.0265 20.2073 22.0265C13.5355 22.0265 7.17111 21.1039 2.94551 19.5418V12.3786C2.94562 12.1606 3.12307 11.9832 3.34121 11.9832ZM37.0965 34.733H3.34121C3.12307 34.733 2.94562 34.5556 2.94562 34.3375V22.4306C6.81303 23.7064 11.8978 24.5038 17.4391 24.7036C17.4388 24.7195 17.4368 24.7347 17.4368 24.7508V25.3521C17.4368 26.4793 18.3539 27.3964 19.4812 27.3964H20.9566C22.084 27.3964 23.001 26.4793 23.001 25.3521V24.7508C23.001 24.7347 22.9988 24.719 22.9987 24.703C28.5435 24.5014 33.6275 23.7017 37.4923 22.4234V34.3376C37.4921 34.5556 37.3146 34.733 37.0965 34.733Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1088_2760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.21875 0.989258)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.e9f96ea187d1810dc472c6ea854a3a84.svg";
export { ForwardRef as ReactComponent };